module.exports = {
  setInstance: function (webApiClientInstance) {
    this.instance = webApiClientInstance;
  },
};
